import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export default function ReportedSuccessfully() {
    const modalTitle = <Typography>Vielen Dank für dein Feedback!</Typography>;
    const modalContent = (
        <ContentTypography>
            Wir kümmern uns schnellstmöglich um dein Anliegen.
        </ContentTypography>
    );
    return { modalTitle, modalContent, autoClosingModal: true };
}
